import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'zepto';
import axios from 'axios';
import { channelPageArtsInfoUrl } from '@/apis';
import TourItem from './TourItem.vue';
import throttle from '@/utils/throttle';
$.fn.scrollL = function (options) {
  var defaults = {
    toLeft: 0,
    // 滚动目标位置
    durTime: 500,
    // 过渡动画时间
    callback: null,
    // 回调函数
    minMoveThreshold: 1 // 每帧最小更新阈值
  };

  var opts = $.extend(defaults, options);
  var _this = this;
  var startLeft = _this.scrollLeft(); // 当前滚动条位置
  var changeLeft = opts.toLeft - startLeft; // 目标位置与当前滚动位置的差值
  var startTime = null; // 动画开始时间
  var lastLeft = startLeft; // 上一次滚动位置

  // 动画函数
  var animateScroll = function animateScroll(timestamp) {
    if (!startTime) startTime = timestamp; // 初始化开始时间
    var timeElapsed = timestamp - startTime; // 当前已过时间
    var progress = Math.min(timeElapsed / opts.durTime, 1); // 计算动画进度

    // 计算新的滚动位置
    var newLeft = startLeft + changeLeft * progress;

    // 使用最小移动阈值来减少更新频率
    if (Math.abs(newLeft - lastLeft) > opts.minMoveThreshold) {
      newLeft = Math.round(newLeft);
      _this.scrollLeft(newLeft);
      lastLeft = newLeft; // 更新滚动位置
    }

    if (progress < 1) {
      requestAnimationFrame(animateScroll);
    } else {
      // 动画完成，执行回调函数
      if (opts.callback && typeof opts.callback === 'function') {
        opts.callback();
      }
    }
  };

  // 启动动画
  requestAnimationFrame(animateScroll);
  return _this;
};
export default {
  name: 'ArtistListNew',
  props: {
    list: {
      type: Array,
      default: []
    },
    categoryId: {
      type: [String, Number],
      default: ''
    },
    mistiming: {
      type: Number,
      default: 0
    }
  },
  components: {
    TourItem: TourItem
  },
  mounted: function mounted() {
    var _this$$refs, _this$$refs$homepageA, _this$$refs2, _this$$refs2$homepage, _this$$refs3, _this$$refs3$homepage;
    this.throttleOnscroll = throttle(this.handleScroll, 150);
    (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$homepageA = _this$$refs.homepageArtistList) === null || _this$$refs$homepageA === void 0 ? void 0 : _this$$refs$homepageA.addEventListener('scroll', this.throttleOnscroll);
    (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 ? void 0 : (_this$$refs2$homepage = _this$$refs2.homepageArtistList) === null || _this$$refs2$homepage === void 0 ? void 0 : _this$$refs2$homepage.addEventListener('scroll', window.StatusReportData, false);
    (_this$$refs3 = this.$refs) === null || _this$$refs3 === void 0 ? void 0 : (_this$$refs3$homepage = _this$$refs3.homepageTourWrapper) === null || _this$$refs3$homepage === void 0 ? void 0 : _this$$refs3$homepage.addEventListener('scroll', window.StatusReportData, false);
    var artistContainerWrapper = document.querySelector('.artist-list-new-wrap');
    var computedStyle = window.getComputedStyle(artistContainerWrapper);
    var processedMarginRight = this.processMargin(computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.marginRight);
    var processedMarginLeft = this.processMargin(computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.marginLeft);
    artistContainerWrapper.style.marginRight = "".concat(processedMarginRight, "px");
    artistContainerWrapper.style.marginLeft = "".concat(processedMarginLeft, "px");
  },
  destroyed: function destroyed() {
    var _this$$refs4, _this$$refs4$homepage, _this$$refs5, _this$$refs5$homepage, _this$$refs6, _this$$refs6$homepage;
    (_this$$refs4 = this.$refs) === null || _this$$refs4 === void 0 ? void 0 : (_this$$refs4$homepage = _this$$refs4.homepageArtistList) === null || _this$$refs4$homepage === void 0 ? void 0 : _this$$refs4$homepage.removeEventListener('scroll', this.throttleOnscroll);
    (_this$$refs5 = this.$refs) === null || _this$$refs5 === void 0 ? void 0 : (_this$$refs5$homepage = _this$$refs5.homepageArtistList) === null || _this$$refs5$homepage === void 0 ? void 0 : _this$$refs5$homepage.removeEventListener('scroll', window.StatusReportData, false);
    (_this$$refs6 = this.$refs) === null || _this$$refs6 === void 0 ? void 0 : (_this$$refs6$homepage = _this$$refs6.homepageTourWrapper) === null || _this$$refs6$homepage === void 0 ? void 0 : _this$$refs6$homepage.removeEventListener('scroll', window.StatusReportData, false);
  },
  data: function data() {
    return {
      activeIndex: 0,
      performance: {},
      cacheData: {},
      tourGroupProjectVoList: [],
      isShowLeftBorder: true,
      isShowLeftTopBorder: false

      // isShowLeftMask: false,
      // isShowRightMask: true,
    };
  },

  methods: {
    processMargin: function processMargin(marginStr) {
      var marginNum = parseFloat(marginStr);
      var integerPart = Math.floor(marginNum);
      var decimalPart = marginNum - integerPart;
      var newDecimalPart;
      if (decimalPart > 0 && decimalPart < 0.25) {
        newDecimalPart = 0;
      } else if (decimalPart >= 0.25 && decimalPart < 0.75) {
        newDecimalPart = 0.5;
      } else if (decimalPart >= 0.75) {
        newDecimalPart = 1;
      }
      return integerPart + newDecimalPart;
    },
    handleShouldShowLeftBorder: function handleShouldShowLeftBorder(activeEleDistanceToLeft, leftBorderMinDistance, leftBorderMaxDistance) {
      if (leftBorderMinDistance <= activeEleDistanceToLeft && activeEleDistanceToLeft <= leftBorderMaxDistance || activeEleDistanceToLeft < 0) {
        this.isShowLeftBorder = false;
      } else {
        this.isShowLeftBorder = true;
      }
    },
    handleShouldShowLeftTopBorder: function handleShouldShowLeftTopBorder(activeEleDistanceToLeft, leftTopRadiusMaxDistance, activeEleDistanceToRight, leftTopRadiusMinDistance) {
      if (leftTopRadiusMaxDistance <= activeEleDistanceToLeft || activeEleDistanceToRight <= leftTopRadiusMinDistance) {
        this.isShowLeftTopBorder = true;
      } else {
        this.isShowLeftTopBorder = false;
      }
    },
    // handleShouldShowLeftMask(activeEleDistanceToLeft, firstEleDistanceToLeft, activeEleDistanceToRight, leftMaskDistance, ratio) {
    //   if (Math.ceil(firstEleDistanceToLeft) < Math.ceil(leftMaskDistance) &&
    //   ( activeEleDistanceToLeft > (ratio * 50) || activeEleDistanceToRight < (ratio * 12))) {
    //     this.isShowLeftMask = true
    //   } else {
    //     this.isShowLeftMask = false
    //   }
    // },
    // handleShouldShowRightMask(activeEleDistanceToLeft, activeEleDistanceToRight, lastEleDistanceToLeft, rightMaskDistance, screenWidth, ratio) {
    //   if (Math.ceil(lastEleDistanceToLeft) > (Math.ceil(rightMaskDistance) + 2) &&
    //   ((screenWidth - activeEleDistanceToRight > ratio * 50) || (
    //     activeEleDistanceToLeft > screenWidth - (ratio * 12)
    //   ))
    //   ) {
    //     this.isShowRightMask = true
    //   } else {
    //     this.isShowRightMask = false
    //   }
    // },
    getDistanceParams: function getDistanceParams() {
      var _document$getElements, _document$getElements2, _window$screen;
      var activeEleRect = (_document$getElements = document.getElementsByClassName('icon-item-active-homepage')) === null || _document$getElements === void 0 ? void 0 : (_document$getElements2 = _document$getElements[0]) === null || _document$getElements2 === void 0 ? void 0 : _document$getElements2.getBoundingClientRect();
      var activeEleDistanceToLeft = activeEleRect === null || activeEleRect === void 0 ? void 0 : activeEleRect.left;
      var activeEleDistanceToRight = activeEleRect === null || activeEleRect === void 0 ? void 0 : activeEleRect.right;
      var screenWidth = (_window$screen = window.screen) === null || _window$screen === void 0 ? void 0 : _window$screen.width;
      var ratio = screenWidth / 375;
      var leftBorderMaxDistance = ratio * 16;
      var leftBorderMinDistance = ratio * 11;
      var leftTopRadiusMaxDistance = ratio * 27;
      var leftTopRadiusMinDistance = ratio * 8;

      // const leftMaskDistance = ratio * 12
      // const rightMaskDistance = ratio * 318
      // const firstEleDistanceToLeft = document.getElementsByClassName('art0')[0]?.getBoundingClientRect()?.left;
      // const lastEleDistanceToLeft = document.getElementsByClassName(`art${this.list?.length - 1}`)?.[0]?.getBoundingClientRect()?.left;

      return {
        activeEleDistanceToLeft: activeEleDistanceToLeft,
        activeEleDistanceToRight: activeEleDistanceToRight,
        screenWidth: screenWidth,
        ratio: ratio,
        leftBorderMaxDistance: leftBorderMaxDistance,
        leftBorderMinDistance: leftBorderMinDistance,
        leftTopRadiusMaxDistance: leftTopRadiusMaxDistance,
        leftTopRadiusMinDistance: leftTopRadiusMinDistance

        // leftMaskDistance,
        // rightMaskDistance,
        // firstEleDistanceToLeft,
        // lastEleDistanceToLeft
      };
    },

    handleScroll: function handleScroll() {
      var _this$getDistancePara = this.getDistanceParams(),
        activeEleDistanceToLeft = _this$getDistancePara.activeEleDistanceToLeft,
        activeEleDistanceToRight = _this$getDistancePara.activeEleDistanceToRight,
        leftBorderMaxDistance = _this$getDistancePara.leftBorderMaxDistance,
        leftBorderMinDistance = _this$getDistancePara.leftBorderMinDistance,
        leftTopRadiusMaxDistance = _this$getDistancePara.leftTopRadiusMaxDistance,
        leftTopRadiusMinDistance = _this$getDistancePara.leftTopRadiusMinDistance;

      // 选中元素左边弧度展示逻辑 选中元素左边距视口左边距离大于11并且小于16 不展示
      this.handleShouldShowLeftBorder(activeEleDistanceToLeft, leftBorderMinDistance, leftBorderMaxDistance);

      // 下方左上圆角展示逻辑 选中元素左边距视口左边距离大于27或者元素右边距视口左边距离小于8 展示
      this.handleShouldShowLeftTopBorder(activeEleDistanceToLeft, leftTopRadiusMaxDistance, activeEleDistanceToRight, leftTopRadiusMinDistance);

      // // 最左蒙层展示逻辑
      // this.handleShouldShowLeftMask(activeEleDistanceToLeft, firstEleDistanceToLeft, activeEleDistanceToRight, leftMaskDistance, ratio)

      // // 最右蒙层展示逻辑
      // this.handleShouldShowRightMask(activeEleDistanceToLeft, activeEleDistanceToRight, lastEleDistanceToLeft, rightMaskDistance, screenWidth, ratio)
    },

    handleChangeTourStatus: function handleChangeTourStatus(obj) {
      this.$emit('changeSaleStatus', obj);
    },
    // 查看更多
    goArtistInfo: function goArtistInfo() {
      var _this$list;
      var _ref = ((_this$list = this.list) === null || _this$list === void 0 ? void 0 : _this$list[this === null || this === void 0 ? void 0 : this.activeIndex]) || {},
        jumpUrl = _ref.jumpUrl;
      if (!jumpUrl) return;
      this.go(jumpUrl, {
        _blank: true
      });
    },
    handleChooseItem: function handleChooseItem(index) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2$list, _artistNameElement$cl, _artistNameElement$cl2, _artistNameElement$cl3, _this2$list2, _this2$list2$index, _this2$cacheData;
        var _ref2, celebrityId, animateName, artistNameElement, tourItemElements, params, str, _this2$cacheData2, _yield$axios$get, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(index === _this2.activeIndex)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", _this2.goArtistInfo());
            case 2:
              _ref2 = ((_this2$list = _this2.list) === null || _this2$list === void 0 ? void 0 : _this2$list[index]) || {}, celebrityId = _ref2.celebrityId;
              window.seedAction({
                evt: 'click',
                bid: 'b_movie_eundh7k9_mc',
                celebrity_id: celebrityId,
                index: index,
                category_id: '1',
                needTag: true
              });

              // tour-wrapper复位
              $('.tour-wrapper').scrollL({
                toLeft: 0,
                durTime: 0
              });
              animateName = index > _this2.activeIndex ? 'animate-right' : 'animate-left';
              _this2.activeIndex = index;
              _this2.$nextTick(function () {
                var _document$getElements3, _document$getElements4, _activeElement$getBou, _firstElement$getBoun, _document$getElementB;
                var activeElement = (_document$getElements3 = document.getElementsByClassName("homepageArt".concat(index))) === null || _document$getElements3 === void 0 ? void 0 : _document$getElements3[0];
                var firstElement = (_document$getElements4 = document.getElementsByClassName("homepageArt".concat(0))) === null || _document$getElements4 === void 0 ? void 0 : _document$getElements4[0];
                var scrollDistance = (activeElement === null || activeElement === void 0 ? void 0 : (_activeElement$getBou = activeElement.getBoundingClientRect()) === null || _activeElement$getBou === void 0 ? void 0 : _activeElement$getBou.left) - (firstElement === null || firstElement === void 0 ? void 0 : (_firstElement$getBoun = firstElement.getBoundingClientRect()) === null || _firstElement$getBoun === void 0 ? void 0 : _firstElement$getBoun.left);
                var decimalPart = scrollDistance - Math.floor(scrollDistance);
                if (decimalPart >= 0.5) {
                  decimalPart = decimalPart - 0.5;
                }
                (_document$getElementB = document.getElementById('artist-list')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scroll({
                  left: decimalPart >= 0.25 ? scrollDistance + 0.5 : scrollDistance,
                  behavior: 'smooth'
                });
                _this2.handleScroll();
              });
              artistNameElement = document.getElementById('artistName');
              (_artistNameElement$cl = artistNameElement.classList) === null || _artistNameElement$cl === void 0 ? void 0 : _artistNameElement$cl.remove('animate-right');
              (_artistNameElement$cl2 = artistNameElement.classList) === null || _artistNameElement$cl2 === void 0 ? void 0 : _artistNameElement$cl2.remove('animate-left');
              artistNameElement.offsetHeight;
              (_artistNameElement$cl3 = artistNameElement.classList) === null || _artistNameElement$cl3 === void 0 ? void 0 : _artistNameElement$cl3.add(animateName);
              tourItemElements = document.querySelectorAll('.tour-item');
              tourItemElements.forEach(function (element) {
                var _element$classList, _element$classList2, _element$classList3;
                (_element$classList = element.classList) === null || _element$classList === void 0 ? void 0 : _element$classList.remove('animate-right');
                (_element$classList2 = element.classList) === null || _element$classList2 === void 0 ? void 0 : _element$classList2.remove('animate-left');
                element.offsetHeight; // 触发重新渲染，确保动画能够重新执行
                (_element$classList3 = element.classList) === null || _element$classList3 === void 0 ? void 0 : _element$classList3.add(animateName); // 重新添加动画类
              });

              params = {
                categoryId: _this2.categoryId,
                celebrityId: (_this2$list2 = _this2.list) === null || _this2$list2 === void 0 ? void 0 : (_this2$list2$index = _this2$list2[index]) === null || _this2$list2$index === void 0 ? void 0 : _this2$list2$index.celebrityId
              };
              str = JSON.stringify(params);
              if (!((_this2$cacheData = _this2.cacheData) !== null && _this2$cacheData !== void 0 && _this2$cacheData[str])) {
                _context.next = 19;
                break;
              }
              return _context.abrupt("return", _this2.performance = (_this2$cacheData2 = _this2.cacheData) === null || _this2$cacheData2 === void 0 ? void 0 : _this2$cacheData2[str]);
            case 19:
              _context.prev = 19;
              _context.next = 22;
              return axios.get(channelPageArtsInfoUrl, {
                params: params
              });
            case 22:
              _yield$axios$get = _context.sent;
              data = _yield$axios$get.data;
              _context.next = 28;
              break;
            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](19);
            case 28:
              _this2.cacheData[str] = _this2.performance;
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[19, 26]]);
      }))();
    },
    // 查看更多
    handleItemClick: function handleItemClick() {
      var _this$list2;
      var _ref3 = ((_this$list2 = this.list) === null || _this$list2 === void 0 ? void 0 : _this$list2[this.activeIndex]) || {},
        jumpUrl = _ref3.jumpUrl,
        celebrityId = _ref3.celebrityId;
      window.lxTagReport('c_6yPP8', 'b_movie_mpfq12r1_mc', {
        celebrity_id: celebrityId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_mpfq12r1_mc',
        custom: {
          celebrity_id: celebrityId
        }
      });
      if (!jumpUrl) return;
      this.go(jumpUrl, {
        _blank: true
      });
    }
  }
};